var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0275B6",
    fillRule: "evenodd",
    d: "M12 6c-3.821 0-7.287 2.104-9.844 5.522a.801.801 0 0 0 0 .952C4.713 15.896 8.18 18 12 18c3.821 0 7.286-2.104 9.843-5.522a.8.8 0 0 0 0-.952C19.286 8.104 15.821 6 12 6zm.274 10.225c-2.536.16-4.631-1.944-4.472-4.501.131-2.108 1.83-3.817 3.924-3.95 2.536-.16 4.631 1.944 4.472 4.502-.135 2.104-1.833 3.813-3.924 3.95zm-.127-1.952a2.269 2.269 0 0 1-2.405-2.421 2.282 2.282 0 0 1 2.115-2.13 2.269 2.269 0 0 1 2.405 2.422c-.073 1.14-.99 2.06-2.115 2.13z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit1);
export default __webpack_public_path__ + "static/media/edit1.3ed890d0d8107c7bc753aa8fbe3e3b6a.svg";
export { ForwardRef as ReactComponent };